const FEEDBACK_DISMISSED_UNTIL_KEY = 'tinyinvoice.feedback.dismissedUntil'

export const FEEDBACK_SNOOZE_MS = 21 * 24 * 60 * 60 * 1000

export const isFeedbackBannerSnoozed = (): boolean => {
  if (typeof window === 'undefined') return true
  try {
    const raw = window.localStorage.getItem(FEEDBACK_DISMISSED_UNTIL_KEY)
    if (!raw) return false
    const dismissedUntil = Number(raw)
    if (!Number.isFinite(dismissedUntil)) return false
    return Date.now() < dismissedUntil
  } catch {
    return false
  }
}

export const snoozeFeedbackBanner = (): void => {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(
      FEEDBACK_DISMISSED_UNTIL_KEY,
      String(Date.now() + FEEDBACK_SNOOZE_MS),
    )
  } catch {
    // ignore quota / private mode errors
  }
}
